var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showActionButtons)?_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"action-buttons__secondary"},[_vm._t("secondary")],2),(_vm.hasDefaultSlotData)?_c('div',{staticClass:"action-buttons__primary"},[_vm._t("default")],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }